import { apiClient, requiresAuth } from '../client';

export const appDownloadsService = {
  getDownloadStats: async () => {
    try {
      return requiresAuth(async () => {
        const response = await apiClient.get('/app-downloads');
        return response.data;
      });
    } catch (error) {
      console.warn(
        '[API] appDownloadsService.getDownloadStats - Endpoint not available, returning mock data:',
        error
      );
      return {
        totalDownloads: 12500,
        totalActiveUsers: 8300,
        appStore: {
          downloads: 7200,
          activeUsers: 4800,
          newUsers: 150,
          deletions: 12,
          updates: 89,
          sessions: 25600,
          crashes: 23,
          impressions: 45200,
          countriesData: [
            { country: 'US', downloads: 3200 },
            { country: 'CA', downloads: 1800 },
            { country: 'UK', downloads: 1200 },
            { country: 'AU', downloads: 800 },
            { country: 'DE', downloads: 200 },
          ],
          apiStatus: 'mock' as const,
          message: 'Endpoint not available - showing mock data',
          lastUpdated: new Date().toISOString(),
        },
        playStore: {
          downloads: 5300,
          activeUsers: 3500,
          newUsers: 120,
          deletions: 8,
          updates: 67,
          sessions: 18900,
          crashes: 15,
          impressions: 32100,
          countriesData: [
            { country: 'US', downloads: 2100 },
            { country: 'CA', downloads: 1200 },
            { country: 'UK', downloads: 900 },
            { country: 'AU', downloads: 600 },
            { country: 'DE', downloads: 500 },
          ],
          apiStatus: 'mock' as const,
          message: 'Endpoint not available - showing mock data',
          lastUpdated: new Date().toISOString(),
        },
      };
    }
  },

  getAppStoreDownloadStats: async () => {
    try {
      return requiresAuth(async () => {
        const response = await apiClient.get('/app-downloads/app-store');
        return response.data;
      });
    } catch (error) {
      console.warn(
        '[API] appDownloadsService.getAppStoreDownloadStats - Endpoint not available:',
        error
      );
      throw error;
    }
  },

  getPlayStoreDownloadStats: async () => {
    try {
      return requiresAuth(async () => {
        const response = await apiClient.get('/app-downloads/play-store');
        return response.data;
      });
    } catch (error) {
      console.warn(
        '[API] appDownloadsService.getPlayStoreDownloadStats - Endpoint not available:',
        error
      );
      throw error;
    }
  },
};
